import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCOdZHoxKW6LyJ6dORxpjjBSG94OpENyQk",
  authDomain: "jncmlaw-7113d.firebaseapp.com",
  projectId: "jncmlaw-7113d",
  storageBucket: "jncmlaw-7113d.firebasestorage.app",
  messagingSenderId: "50240998496",
  appId: "1:50240998496:web:523a1c6562d1c802138705",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
const db = getFirestore(app);
export { db }; 
